/**
 * ISO-Kalenderwochen-Helpers (KW-53-faehig, G-17).
 *
 * Regel aus den Coding-Standards: lokale Kalenderdaten sind "YYYY-MM-DD"-Strings.
 * Alle Berechnungen laufen ueber UTC-Konstruktion, damit es keine Timezone-/
 * DST-Verschiebungen gibt. Jahrwochen NIE als String — immer (year, week).
 */

const DAY_MS = 86_400_000

function toIso(d: Date): string {
  const y = d.getUTCFullYear()
  const m = String(d.getUTCMonth() + 1).padStart(2, "0")
  const day = String(d.getUTCDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}

function parseUtc(iso: string): Date {
  const [y, m, d] = iso.split("-").map(Number)
  return new Date(Date.UTC(y, m - 1, d))
}

/** Heutiges lokales Kalenderdatum als "YYYY-MM-DD" (ohne toISOString-Shift) */
export function todayIso(): string {
  const now = new Date()
  const m = String(now.getMonth() + 1).padStart(2, "0")
  const d = String(now.getDate()).padStart(2, "0")
  return `${now.getFullYear()}-${m}-${d}`
}

/** Datum + n Tage (n darf negativ sein) */
export function addDaysIso(iso: string, days: number): string {
  const d = parseUtc(iso)
  d.setUTCDate(d.getUTCDate() + days)
  return toIso(d)
}

/** ISO-Jahr + ISO-KW eines Kalenderdatums (Donnerstags-Regel) */
export function isoWeekOf(iso: string): { year: number; week: number } {
  const d = parseUtc(iso)
  const dayNum = (d.getUTCDay() + 6) % 7 // Mo=0 … So=6
  d.setUTCDate(d.getUTCDate() - dayNum + 3) // Donnerstag der Woche
  const year = d.getUTCFullYear()
  const jan4 = Date.UTC(year, 0, 4)
  const jan4DayNum = (new Date(jan4).getUTCDay() + 6) % 7
  const mondayW1 = jan4 - jan4DayNum * DAY_MS
  const week = Math.floor((d.getTime() - mondayW1) / (7 * DAY_MS)) + 1
  return { year, week }
}

/** Montag einer ISO-KW als "YYYY-MM-DD" */
export function mondayOfIsoWeek(year: number, week: number): string {
  const jan4 = new Date(Date.UTC(year, 0, 4))
  const jan4DayNum = (jan4.getUTCDay() + 6) % 7
  const mondayW1 = new Date(jan4.getTime() - jan4DayNum * DAY_MS)
  mondayW1.setUTCDate(mondayW1.getUTCDate() + (week - 1) * 7)
  return toIso(mondayW1)
}

/** Anzahl ISO-KWs eines Jahres (52 oder 53; 2026 hat 53) */
export function weeksInIsoYear(year: number): number {
  return isoWeekOf(`${year}-12-28`).week
}

/** Deutsche Kurz-Wochentagsnamen, Index 0 = Montag */
export const WEEKDAYS_DE = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"] as const
